import script from "./LogoutConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./LogoutConfirmDialog.vue?vue&type=script&setup=true&lang=ts"

import "./LogoutConfirmDialog.vue?vue&type=style&index=0&id=28138da7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28138da7"]])

export default __exports__